function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.016
});

var SvgStarFilledBlack = function SvgStarFilledBlack(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 4.2333 4.2333",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", null, /*#__PURE__*/React.createElement("rect", {
    x: -4.991,
    y: -2.5618,
    width: 12.991,
    height: 20.938,
    style: {
      fillRule: "evenodd",
      fill: "#00f"
    }
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter52",
    x: -0.0024,
    y: -0.0024,
    width: 1.0048,
    height: 1.0048,
    style: {
      colorInterpolationFilters: "sRGB"
    }
  }, _ref2)), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.26332 0 0 .26332 .010111 .010111)",
    style: {
      filter: "url(#filter52)",
      opacity: 0.999
    }
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m9.12 0s1.92 6.08 1.92 6.08h6.08l-4.96 3.84s1.92 6.08 1.92 6.08l-4.96-3.84-4.96 3.84s1.92-6.08 1.92-6.08l-4.96-3.84h6.08s1.92-6.08 1.92-6.08z",
    vectorEffect: "non-scaling-stroke",
    style: {
      fill: "#ebebeb",
      strokeWidth: 0
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.26458 0 0 .26458 -.29633 0)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m9.12 0s1.92 6.08 1.92 6.08h6.08l-4.96 3.84s1.92 6.08 1.92 6.08l-4.96-3.84-4.96 3.84s1.92-6.08 1.92-6.08l-4.96-3.84h6.08s1.92-6.08 1.92-6.08z",
    vectorEffect: "non-scaling-stroke",
    style: {
      strokeWidth: 0
    }
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgStarFilledBlack, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/star-filled-black.2447ff4c.svg";
export { ForwardRef as ReactComponent };